import { Component, OnInit } from '@angular/core';
import { ModalComponent } from 'app/core/modal.component';
@Component({
  selector: 'app-chat-users-modal',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class ChatUsersModalComponent extends ModalComponent implements OnInit {

  ngOnInit() {
  }
}


